import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Highlights.css";
import destinationImg from "../../assets/highlights/destinations.webp";
import Events from "../../assets/highlights/Events.webp";
import customersImg from "../../assets/highlights/customers.webp";
import supportImg from "../../assets/highlights/support.webp";
import experienceImg from "../../assets/highlights/experience.webp";
import plansImg from "../../assets/highlights/plans.webp";
import reviewsImg from "../../assets/highlights/reviews.webp";
import TripCompleted from "../../assets/highlights/Tripcompleted.webp";

function Highlights() {
  const highlights = [
    {
      number: 50,
      label: "Events",
      icon: <img src={Events} alt="Events" className="highlight-icon" />,
      animate: true,
    },
    {
      number: 290,
      label: "Destinations",
      icon: (
        <img
          src={destinationImg}
          alt="Destinations"
          className="highlight-icon"
        />
      ),
      animate: true,
    },
    {
  number: 1000000, 
  label: "Satisfied Customers",
  icon: (
    <img src={customersImg} alt="Customers" className="highlight-icon" />
  ),
  animate: true,
},
    {
      number: 24,
      label: "Support (Hours)",
      icon: <img src={supportImg} alt="Support" className="highlight-icon" />,
      animate: false,
    },
    {
      number: 12,
      label: "Years of Experience",
      icon: (
        <img src={experienceImg} alt="Experience" className="highlight-icon" />
      ),
      animate: true,
    },
    {
      number: 100,
      label: "Customized Plans (%)",
      icon: <img src={plansImg} alt="Plans" className="highlight-icon" />,
      animate: false,
    },
    {
      number: 950,
      label: "Trips Completed",
      icon: (
        <img
          src={TripCompleted}
          alt="Trips Completed"
          className="highlight-icon"
        />
      ),
      animate: true,
    },
    {
      number: 4.9,
      label: "Google Rating",
      icon: (
        <img
          src={reviewsImg}
          alt="Google Reviews"
          className="highlight-icon"
        />
      ),
      animate: false,
    },
  ];

  const [counts, setCounts] = useState(highlights.map(() => 0));

  const runCounter = (end, index) => {
    let start = 0;
    const duration = 1000;
    const increment = end / (duration / 30);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setCounts((prev) => {
        const updated = [...prev];
        updated[index] = Math.floor(start);
        return updated;
      });
    }, 30);
  };

  return (
    <section className="highlights-section">
      <h1 className="highlights-heading">Our Highlights</h1>

      <div className="highlights-container">
        {highlights.map((item, index) => (
          <motion.div
            key={index}
            className="highlight-card"
            whileInView={{
              opacity: 1,
              y: 0,
              transition: { duration: 0.6, ease: "easeOut" },
            }}
            viewport={{ once: false, amount: 0.5 }}
            onViewportEnter={() => {
              if (item.animate) {
                setCounts((prev) => {
                  const updated = [...prev];
                  updated[index] = 0;
                  return updated;
                });
                runCounter(item.number, index);
              } else {
                setCounts((prev) => {
                  const updated = [...prev];
                  updated[index] = item.number;
                  return updated;
                });
              }
            }}
          >
            <div className="highlight-icon">{item.icon}</div>
            <h2 className="highlight-number">
              {counts[index]}
              {item.label.includes("%")
                ? "%"
                : item.label.includes("Customers") ||
                  item.label.includes("Destinations") ||
                  item.label.includes("Years of Experience") ||
                  item.label.includes("Trips Completed") ||
                  item.label.includes("Events")
                ? "+"
                : ""}
            </h2>
            <p className="highlight-label">{item.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Highlights;
